module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp10-4f9effdcb55b120a81c621280ef28bad.jpg";